"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = DropdownNavItem;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _gatsby = require("gatsby");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _generic = _interopRequireDefault(require("../icons/generic"));
var _utils = require("../../utils/utils");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// Packages

// Components

// Utils

const {
  canHover,
  above
} = (0, _utils.getMediaQueries)();

// Styles
const Container = _styledComponents.default.div.withConfig({
  displayName: "dropdown-item__Container",
  componentId: "sc-213ln8-0"
})(["a{text-decoration:none;}&.desktop .dropdown-subnav-items.dropdown-open{background:var(--arctic-blue-1-hex);padding:24px;position:absolute;right:0;top:150%;width:416px;}a.dropdown-nav-item{position:relative;font-size:18px;line-height:24px;color:black;text-decoration:none;font-weight:400;padding:18px 10px;transition:0.2s ease-in-out;margin-right:12px;::before{content:\"\";position:absolute;width:100%;height:4px;bottom:0;left:0;background-color:#0b7df4;visibility:hidden;transform:scaleX(0);transition:0.3s ease-in-out;", "}:hover{::before{visibility:visible;transform:scaleX(1);}}&.active{::before{visibility:visible !important;transform:scaleX(1) !important;}}}.dropdown-nav-item{cursor:pointer;position:relative;display:block;text-align:left;font-size:32px;line-height:40px;color:black;text-decoration:none;font-weight:400;padding:8px 0;margin:0;margin-bottom:8px;::before{content:\"\";position:absolute;width:100%;height:4px;bottom:0;left:0;background-color:#0b7df4;visibility:hidden;transform:scaleX(0);transition:0.3s ease-in-out;", "}", " &.active{::before{visibility:visible !important;transform:scaleX(1) !important;}}", ";}.main-item-content{align-items:center;cursor:pointer;display:flex;svg{margin-left:8px;}}"], above.tablet`
        height: 2px;
      `, above.tablet`
        height: 2px;
      `, canHover`
      :hover::before {
        visibility: visible;
        transform: scaleX(1);
      }
    `, above.tablet`
      position: relative;
      font-size: 18px;
      line-height: 24px;
      color: black;
      text-decoration: none;
      font-weight: 400;
      padding: 18px 10px;
      transition: 0.2s ease-in-out;
      margin-right: 12px;
      margin-bottom: 0;
    `);
const Link = (0, _styledComponents.default)(_gatsby.Link).withConfig({
  displayName: "dropdown-item__Link",
  componentId: "sc-213ln8-1"
})([""]);
const SubNavItems = _styledComponents.default.div.withConfig({
  displayName: "dropdown-item__SubNavItems",
  componentId: "sc-213ln8-2"
})(["z-index:100;"]);
const SubNavItem = _styledComponents.default.div.withConfig({
  displayName: "dropdown-item__SubNavItem",
  componentId: "sc-213ln8-3"
})(["& > *{display:block;padding:16px 8px;}a{transition:all 0.3s ease-in-out;::before{display:none;}:active{background:var(--arctic-blue-2-hex);cursor:pointer;text-decoration:none;}", "}.content{display:flex;text-align:left;p{margin:0;}div{margin-left:8px;}svg{flex-shrink:0;}.subtext{color:var(--dusky-grey-6-hex);font-size:14px;line-height:16px;}.text{color:var(--arctic-blue-hex);font-weight:700;font-size:16px;line-height:20px;}}"], canHover`
      :hover {
        background: var(--arctic-blue-2-hex);
        cursor: pointer;
        text-decoration: none;
      }
    `);

// Main Component
function DropdownNavItem({
  screen,
  mainItem,
  linkAttributes,
  subNavItems
}) {
  const {
    0: isDropdownOpen,
    1: setIsDropdownOpen
  } = (0, _react.useState)(false);
  const functions = {
    onClick: () => {
      setIsDropdownOpen(!isDropdownOpen);
    }
  };
  const mainItemContent = /*#__PURE__*/_react.default.createElement("span", {
    className: "main-item-content"
  }, mainItem, " ", isDropdownOpen ? /*#__PURE__*/_react.default.createElement(_generic.default, {
    icon: "chevron-up"
  }) : /*#__PURE__*/_react.default.createElement(_generic.default, {
    icon: "chevron-down"
  }));
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Container, Object.assign({
    className: `${screen} `
  }, functions), linkAttributes ? /*#__PURE__*/_react.default.createElement(Link, Object.assign({}, linkAttributes, {
    className: "dropdown-nav-item",
    as: linkAttributes && linkAttributes.href ? "a" : _gatsby.Link
  }), mainItemContent) : /*#__PURE__*/_react.default.createElement("div", {
    className: "dropdown-nav-item"
  }, mainItemContent), isDropdownOpen && /*#__PURE__*/_react.default.createElement(SubNavItems, {
    className: `${isDropdownOpen ? "dropdown-open" : ""} dropdown-subnav-items`
  }, subNavItems.map(item => {
    if (!item) return null;
    const {
      icon,
      text,
      subtext,
      linkAttributes
    } = item;
    const content = /*#__PURE__*/_react.default.createElement("div", {
      className: "content"
    }, icon && icon, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", {
      className: "text"
    }, text), subtext && /*#__PURE__*/_react.default.createElement("p", {
      className: "subtext"
    }, subtext)));
    return /*#__PURE__*/_react.default.createElement(SubNavItem, {
      className: "dropdown-subnav-item",
      key: `subnav-item-${text.replace(/\s/g, "-")}`
    }, linkAttributes ? /*#__PURE__*/_react.default.createElement(Link, Object.assign({}, linkAttributes, {
      activeClassName: "active",
      as: linkAttributes && linkAttributes.href ? "a" : _gatsby.Link
    }), content) : content);
  }))));
}
DropdownNavItem.propTypes = {
  /**
   * Is the nav item going to be shown on a mobile (tablet size included) screen or desktop screen? <br /> <br />
   * If you choose desktop, a parent of the nav item must have position relative in order for the nav item to properly show
   */
  screen: _propTypes.default.oneOf(["mobile", "desktop"]),
  /**
   * Text for the main item that has toggle capability to toggle sub nav items
   */
  mainItem: _propTypes.default.string.isRequired,
  /**
   * Array of objects
   * Each object should contain text, subtext (optional), icon (optional), and linkTo
   */
  subNavItems: _propTypes.default.array.isRequired,
  /**
   * Link Attributes e.g. { to: "/", target: "_blank"}
   */
  linkAttributes: _propTypes.default.shape()
};
DropdownNavItem.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "DropdownNavItem",
  "props": {
    "screen": {
      "description": "Is the nav item going to be shown on a mobile (tablet size included) screen or desktop screen? <br /> <br />\nIf you choose desktop, a parent of the nav item must have position relative in order for the nav item to properly show",
      "type": {
        "name": "enum",
        "value": [{
          "value": "\"mobile\"",
          "computed": false
        }, {
          "value": "\"desktop\"",
          "computed": false
        }]
      },
      "required": false
    },
    "mainItem": {
      "description": "Text for the main item that has toggle capability to toggle sub nav items",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "subNavItems": {
      "description": "Array of objects\nEach object should contain text, subtext (optional), icon (optional), and linkTo",
      "type": {
        "name": "array"
      },
      "required": true
    },
    "linkAttributes": {
      "description": "Link Attributes e.g. { to: \"/\", target: \"_blank\"}",
      "type": {
        "name": "shape",
        "value": "PropTypes.shape()",
        "computed": true
      },
      "required": false
    }
  }
};